import React from 'react';
import PropTypes from "prop-types";

const DiscountPercentColumn = ({ row }) => {
    const hasCustomerDiscount = Number.isFinite(row.CustomerDiscount);
    const hasDiscountPercent = Number.isFinite(row.DiscountPercent);

    let className = '';

    if (hasCustomerDiscount && !hasDiscountPercent) {
        className = 'CustomerDiscount';
    } else if (hasCustomerDiscount && hasDiscountPercent) {
        className = 'DiscountPercent';
    }

    return <span className={className}>{row.DiscountPercent ?? row.CustomerDiscount}</span>;
};

DiscountPercentColumn.propTypes = {
	row: {
		DiscountPercent: PropTypes.bool,
		CustomerDiscount: PropTypes.bool,
	}
}

export default DiscountPercentColumn;
